export default "__VITE_ASSET__a135c168__"